import { ref, onMounted, reactive } from "vue";
import BannerSwiper from "@/components/BannerSwiper/index.vue";
import Media from "@/pages/MediaReport/components/media.vue";
export default {
  components: {
    BannerSwiper: BannerSwiper,
    Media: Media
  },
  name: "Index",
  setup: function setup() {
    var bannerList = reactive([{
      id: 0,
      // imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_media_banner_03.png",
      imageUrl: require('./image/1-1.jpg')
    }]);
    return {
      bannerList: bannerList
    };
  }
};